export default __webpack_public_path__ + "560d4d0f81af03cfed27e6ec86bee8f3.gif";